import Api from '../api/Api';
import resolve from  '../util/Configuracao';
class TipoAtendimentoApi extends Api {
  async consultarTiposAtendimento () {
    try {
      const urlConsultarTiposAtendimento = resolve('urlConsultarTiposAtendimento');
      const response = await this.fetch(urlConsultarTiposAtendimento);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCaraterSolicitacao () {
    try {
      const urlConsultarCaraterSolicitacao = resolve('urlConsultarCaraterSolicitacao');
      const response = await this.fetch(urlConsultarCaraterSolicitacao);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarTipoAtendimentoSpsadt (codLoteGuia, codGuia, codTipoGuia, codTipoAtendimento) {
    const urlAlterarTipoAtendimentoSpsadt = resolve('urlAlterarTipoAtendimentoSpsadt') + codLoteGuia + '/guia/' + codGuia + '/tipo/' + codTipoGuia + '/tipo_atendimento/' + codTipoAtendimento;
    try {
      const result = await this.fetch(urlAlterarTipoAtendimentoSpsadt, 'PUT');
      return result;
    } catch (error) {
      return error;
    }
  }
  async alterarCaraterSolicitacao (codLoteGuia, codGuia, codTipoGuia, codCaraterSolicitacao) {
    const urlAlterarCaraterSolicitacao = resolve('urlAlterarCaraterSolicitacao') + codLoteGuia + '/guia/' + codGuia + '/tipo/' + codTipoGuia + '/carater_solicitacao/' + codCaraterSolicitacao;
    try {
      const result = await this.fetch(urlAlterarCaraterSolicitacao, 'PUT');
      return result;
    } catch (error) {
      return error;
    }
  }
}

export default TipoAtendimentoApi;
